import styled from "styled-components";
import Text from "@streeteasy/design-system/deprecated/Text";

const QuestionMarkWrapper = styled.span`
  white-space: nowrap;
`;

const SuggestedEmailContainer = styled.div`
  align-items: center;
  background-color: #e5f4fc; // Can we find a color from our color palette?
  box-sizing: border-box;
  display: ${props => (props.isVisible ? "flex" : "none")};
  justify-content: center;
  min-height: 40px;
`;

const SuggestedEmailText = styled(Text).attrs({
  type: "sm"
})`
  padding: 10px 20px;
  text-align: center;
  word-break: break-word;
`;

QuestionMarkWrapper.displayName = "QuestionMarkWrapper ";
SuggestedEmailContainer.displayName = "SuggestedEmailContainer";
SuggestedEmailText.displayName = "SuggestedEmailText";

export { QuestionMarkWrapper, SuggestedEmailContainer, SuggestedEmailText };
